import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    complaints: [],
    complaint: {},
    totalItems: 0,

};

const getters = {
    index: state => complaintId => state.complaints.findIndex(i => i.complaintId === complaintId)
};

const mutations = {
    setComplaints: (state, r) => (state.complaints = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    reply: (state, index) => state.complaints[index].status = status.replyed,
    setComplaint: (state, r) => (state.complaint = r),

 

};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading()
            const response = await dataService.complaints.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setComplaints", response.data.complaints);
            commit("setTotalItems", response.data.totalItems);


        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async reply({ commit, getters }, { id, payload }) {
        try {
            
            startLoading()
            const response = await dataService.complaints.reply(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showNotification(response.data.message);

            const index = getters.index(id);
            commit("reply", index);
   
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setComplaint", {});
            startLoading()
            const response = await dataService.complaints.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setComplaint", response.data.complaint);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },



};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
